//project imports
import cnt from "../../services/definedConstant";

const INITIAL_STATE = {
  isSignedIn: false,
  userToken: false,
  userData: false,
  configData: {},
  lockscreenData: {
    userName: null,
    profileFirstName: null,
    profileLastName: null,
  },
  authBuffer: "",
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case cnt.SIGN_IN:
      return {
        ...state,
        isSignedIn: true,
        userToken: payload.session,
        userData: payload,
        configData: payload.configData,
        // lockscreenData:{
        //   userName:payload.userData.userName,
        //   firstName:payload.userData.profileFirstName,
        //   lastName:payload.userData.profileLastName,
        //   fullName: payload.userData.profileFirstName + ' ' + payload.userData.profileLastName
        // }
      };
    case cnt.AUTH_BUFFER:
      return {
        ...state,
        authBuffer: payload,
      };
    case cnt.SIGN_OUT:
      // initiate the whole of object.
      return {
        ...INITIAL_STATE,
        userToken: null,
        userData: {},
        isAuthenticated: false,
      };
    case cnt.LOCKSCREEN:
      // initiate the part of object.
      return {
        ...state,
        isSignedIn: false,
        userToken: false,
        userData: false,
        configData: {},
      };
    default:
      return state;
  }
};
